import { lazy } from 'react';
import type { AppRoute } from '@/app/registry';
import { CP } from '@/api/commercial';

/**
 * Order-first routes (sale enters the order → giám đốc duyệt → ký HĐ → đào tạo), spread into APP_ROUTES by src/app/registry.tsx.
 * The order detail stays at /orders/:id (OrderDetailPage renders the order-first view for ORDER_FIRST orders).
 */
export const commercialRoutes: AppRoute[] = [
  {
    path: 'order-first/new',
    title: 'Tạo đơn hàng',
    perms: [CP.orderWrite],
    page: lazy(() => import('./orderFirst/OrderFirstFormPage')),
  },
  {
    path: 'order-first/:id/edit',
    title: 'Sửa đơn hàng',
    perms: [CP.orderWrite],
    page: lazy(() => import('./orderFirst/OrderFirstFormPage')),
  },
];
